import React from 'react';
import Link from '@mlb/react-patterns/components/Link/link';

import { useMediaConfig, useLang } from '../../hooks/config';
import StatusTemplate from '../StatusTemplate';

const StatusMessage = () => {

    const lang = useLang();
    const { statusMessage = {} } = useMediaConfig();
    const title = statusMessage.title || {};
    const message = statusMessage.message || {};
    const link = statusMessage.link || {};
    const linkText = link.text || {};
    const linkUrl = link.url;
    return (
        <StatusTemplate
            title={title[lang] || 'Oops, something went wrong.'}
            message= {
                <>
                    {message[lang] || 'Try reloading the page.'}
                    {linkUrl && (
                        <>
                            &nbsp;
                            <Link
                                url={linkUrl}
                                target={'_blank'}
                            >
                                {linkText[lang]}
                            </Link>.
                        </>
                    )}
                </>
            }
        />
    );

};

export default StatusMessage;
